/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'
import router from '../router/index.js'
import { Toast } from 'vant'
// axios.defaults.baseURL = ''
// 请求超时时间
axios.defaults.timeout = 5000
axios.defaults.withCredentials = true
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 环境的切换
// 测试地址 https://testa.soujingpin.com
// 本地地址 http://192.168.109.101:8091/
// development
// production
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'https://ipa.soujingpin.com'
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://ipa.soujingpin.com'
}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    // if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    //   token && (config.headers.Authorization = token)
    //   config.headers.Authorization = token
    // }
    // console.log(localStorage.getItem('token'))

    var AUTH_TOKEN = localStorage.getItem('token')
    // 给当前请求设置请求头
    if (config.url === '/order/orderSubmitBuy' || config.url === '/order/orderSubmitCart') {
      console.log('===================================================================')
      config.headers = {
        'Content-Type': 'application/json'
      }
    } else {
      if (config.method === 'get') {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      }
      if (config.method === 'post') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }

    config.headers.Authorization = 'Bearer ' + AUTH_TOKEN
    // config.headers.Authorization = 'Bearer ' + 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ5b3lvIiwiY3JlYXRlZCI6MTU5ODUxNzAxMzg5MCwiZXhwIjoxNjA0NTY1MDEzfQ.fOVxLB1wnnv6fpJ7tMA1QvVW08SHh-aNsBYnzncWIghRRYMtV5iSOuy5_Cek1g9vSBBNbPa9S-dPUW9h-wSWCg'
    // eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODYwMDc1ODYyOCIsImNyZWF0ZWQiOjE1ODkxNjY3NTI4MjQsImV4cCI6MTU5NTIxNDc1Mn0.I4_XhS-MbZBx8azA4tKzUECwf25bWu1fWwxQYgq8ztgB61nxYV5OCpBXCQ4pC4N-AE09VAxpHqhn2Hu8nkoNbA
    return config
  },
  error => {
    return Promise.reject(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code === 401) {
        Toast.fail('未登录')
        return false
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error)
    const { response } = error
    // 如果服务器有返回结果
    if (response) {
      switch (response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          Toast.fail('未登录')
          break
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
        case 403:
          console.log('报错403')
          // 清除token
          localStorage.removeItem('token')
          // store.commit('loginSuccess', null)
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/Login'
            })
          }, 1000)
          break
          // 404请求不存在
        case 404:
          console.log('报错404')
          break
        case 500:
          console.log('报错500')
          break
          // 其他错误，直接抛出错误提示
        // default:
        //   console.log('其他错误')
      }
      return Promise.reject(error.response)
    } else {
      // 服务器连结果都没有返回
    //   if (!window.navigator.onLine) {
    //     this.$router.push('fiul500')
    //     // 跳转断网界面
    //   }
      return Promise.reject(error)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  // console.log(params)
  return new Promise((resolve, reject) => {
    if (params) {
      // 支付接口payType
      if (params.payType === 0) {
        console.log('支付接口的post')
        axios.post(url, params)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err.data)
          })
      } else {
        console.log('有参数的post')
        axios.post(url, QS.stringify(params))
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err.data)
          })
      }
    } else {
      console.log('没有参数的post')
      axios.post(url, QS.stringify(params))
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    }
  })
}
